import { render } from "./login.vue?vue&type=template&id=5af3ce94&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=5af3ce94&scoped=true&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af3ce94"]])

export default __exports__